<template>
  <div class="installation">
    <div class="container">
      <img
        class="installation-logo"
        src="@/assets/images/logo-white.svg"
        alt="Logo du Théatre de Liège"
      >
      <p
        v-if="platform === 'ios'"
        class="installation-text"
      >
        Ajoutez notre application web à votre écran d'accueil.<br>
        <strong>Etape 1 :</strong> Appuyez sur l'icône <img src="@/assets/images/installation-ios.svg" alt="Bouton d'installation iOS"> de votre écran.<br>
        <strong>Etape 2 :</strong> Choisissez "Sur l'écran d'accueil"<br>
        <strong>Etape 3 :</strong> Donnez-lui un nom et appuyez sur "Ajouter"
      </p>

      <p
        v-if="platform === 'android'"
        class="installation-text"
      >
        Ajoutez notre application web à votre écran d'accueil.<br> Appuyez simplement sur l'icône de menu de votre navigateur puis sur "Installer l'application".
        <btn v-if="deferredPrompt"
          :theme="'bordered'"
          @click="$emit('install')">
          Installer l'application
        </btn>
      </p>

      <button
        class="installation-close"
        @click="$emit('close')"
      >
        <sprite
          :type="'close'"
          :width="12"
          :height="12"
        />
      </button>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/components/Sprite.vue';
import Btn from '@/components/components/Btn.vue';

export default {
  components: {
    Sprite,
    Btn
  },
  props: {
    platform: {
      type: String,
      required: true
    },
    deferredPrompt: {
      type: Event
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    onClose() {
      localStorage.setItem('installation-off', 'true');
    }
  }
};
</script>

<style lang="scss" scoped>
.installation {
  @include position(fixed, null null 0 0);
  @include padding(16px null 22px);
  @include size(100%, auto);
  z-index: 1001;
  background-color: $primary;

  &.hidden {
    display: none;
  }

  .container {
    @include padding(null 16px);
    display: flex;
    align-items: flex-start;
  }

  &-logo {
    @include size(44px);
  }

  &-text {
    @include padding(null null null 24px);
    flex-grow: 1;
    color: $white;
    font-size: rem(14px);
    line-height: (21 / 14);

    img {
      display: inline-block;
      vertical-align: middle;
    }

    .btn {
      @include margin(10px null null);
    }
  }

  &-close {
    @include margin(-16px -16px null null);
    @include padding(16px 16px 24px 24px);

    .svg {
      display: block;
      fill: $white;
    }
  }
}
</style>
